import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../constants/languages";
import Typography from "@material-ui/core/Typography";

export default class BrowserWarningDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="form-dialog-title">
          {languages.general.browserNotSupported}
        </DialogTitle>
        <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
          <Typography>{languages.general.messageIE}</Typography>
        </DialogContent>
      </Dialog>
    );
  }
}
